import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import MenuItem from './MenuItem';
import SubMenu from './SubMenu';
import User from './User';
import UserProfile from './UserProfile';
import ivclass from '../../../../Modules/IVClass';
import AppPromo from '../AppPromo';
var MenuType;
(function (MenuType) {
    MenuType["MAIN_MENU"] = "MAIN_MENU";
    MenuType["PROFILE_MENU"] = "PROFILE_MENU";
})(MenuType || (MenuType = {}));
const MainMenu = (props) => {
    const { menu, onLogin, onSignUp, os, logoutRedirectLink, authFunctions } = props;
    const [current, setCurrent] = useState(MenuType.MAIN_MENU);
    const [backButtonArray, setBackButtonArray] = useState([]);
    const onNext = (key) => {
        setBackButtonArray(result => [...result, current]);
        setCurrent(key);
    };
    const onBack = () => {
        const length = backButtonArray.length - 1;
        setCurrent(backButtonArray[length]);
        setBackButtonArray(state => [...state.slice(0, length)]);
    };
    function getCurrentSubMenu() {
        if (backButtonArray.length === 2) {
            const nestedSubMenu = menu[backButtonArray[1]];
            const { links } = nestedSubMenu;
            return links?.[current];
        }
        return menu[current];
    }
    const currentSubMenu = getCurrentSubMenu();
    return (_jsxs(React.Fragment, { children: [_jsx("div", { className: ivclass('iv-flex-grow', 'iv-mx-15'), children: (current === MenuType.MAIN_MENU &&
                    Object.keys(menu).map((item, idx) => {
                        const { color, external, name, icon, type, url, platform, linkKey, showAuth, } = menu[item];
                        return (_jsx("div", { className: ivclass('iv-pt-25'), children: _jsx(MenuItem, { objectKey: item, className: ivclass('iv-inline-block', 'iv-pr-8', color || 'iv-text-grey-50', 'iv-m-heading-3xs', 'iv-text-heading-3xs', 'iv-font-semibold'), color: color, external: external, icon: icon, name: name, type: type, url: url, onNext: onNext, platform: platform, linkKey: linkKey, showAuth: showAuth, authFunctions: authFunctions }) }, idx));
                    })) ||
                    (current === MenuType.PROFILE_MENU && (_jsx(UserProfile, { onBack: onBack, logoutRedirectLink: logoutRedirectLink }))) ||
                    (currentSubMenu && (_jsx(SubMenu, { subMenu: currentSubMenu, objectKey: current, onBack: onBack, onNext: onNext, authFunctions: authFunctions }))) }), _jsxs("div", { children: [current === MenuType.MAIN_MENU && (_jsx("div", { className: ivclass('iv-py-25'), children: _jsx(User, { onNext: () => onNext(MenuType.PROFILE_MENU), onLogin: onLogin, onSignUp: onSignUp, logoutRedirectLink: logoutRedirectLink }) })), _jsx(AppPromo, { os: os })] })] }));
};
export default MainMenu;
